import { render, staticRenderFns } from "./RankHistoryNew.vue?vue&type=template&id=08d85b30&scoped=true&lang=pug&"
import script from "./scripts/RankHistoryNew.js?vue&type=script&lang=js&"
export * from "./scripts/RankHistoryNew.js?vue&type=script&lang=js&"
import style0 from "./RankHistoryNew.vue?vue&type=style&index=0&id=08d85b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d85b30",
  null
  
)

export default component.exports